import {
  GET_PAYMENT_FAILURE,
  GET_PAYMENT_REQUEST,
  GET_PAYMENT_SUCCESS,
} from "./paymentTypes";

const initialStateForGetPayment = {
  loading: false,
  payment: [],
  error: "",
};

const getPaymentReducer = (state = initialStateForGetPayment, action) => {
  switch (action.type) {
    case GET_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PAYMENT_SUCCESS:
      return {
        loading: false,
        payment: action.payload,
        error: "",
      };
    case GET_PAYMENT_FAILURE:
      return {
        loading: false,
        payment: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getPaymentReducer };
